import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {PaymentFailedIcon} from "../../../../SVGElements";
import {Messages} from "../../../../Messages";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../../common/MerchantButton";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {BasePanelPage, BasePanelPageStyle} from "../BasePanelPage";
import {Controller} from "../../../Controller";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {PAYMENT_DETAILS_PANEL_URL} from "../../../PanelConstants";


export class PaymentFailedPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        textAlign: "center",
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(PaymentFailedPanelStyle)
export class PaymentFailedPanel extends BasePanelPage {
    formatPaymentErrorMessage(message) {
        let formattedMessage = (message || "").toString().trim();

        if (!formattedMessage.length) {
            return formattedMessage;
        }

        if (formattedMessage.slice(-1) !== ".") {
            formattedMessage += ".";
        }

        formattedMessage += " ";

        return formattedMessage;
    }

    render() {
        const {styleSheet} = this;


        return [
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null :
                <PaymentFailedIcon className={styleSheet.icon} color={this.styleSheet.themeProps.MERCHANT_TEXT_SECONDARY_COLOR}/>,
            <div testId="subscribeFailedTitle" className={styleSheet.title}>
                {Messages.subscribePaymentFailedModal}</div>,
            <div testId="subscribeFailedMessage" className={styleSheet.message}>
                {Controller.paymentMethod.isCDSPaymentError() && iFrameMerchantService.isMerchant(TNR_ALIAS) ?
                    // TODO @Mihai @Darius Make the message element accept <a>.
                    [Messages.tnrContactCustomerSupport, <Link className={styleSheet.link} value={Messages.tnrContactCustomerSupportLink} href={Messages.tnrCustomerSupportLink.toString()}/>, "."] :
                    [this.formatPaymentErrorMessage(Controller.paymentMethod.getPaymentErrorMessage()), Messages.subscribeFailedMessage]}
            </div>,
            <MerchantButton className={styleSheet.button}
                            onClick={() => Router.changeURL(PAYMENT_DETAILS_PANEL_URL)}>
                {Messages.editPaymentDetails}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => {
                    const retryPayment = Controller.paymentMethod.retryPayment || Controller.paymentMethod.onSelectSuccess;
                    retryPayment();
                }}>
                    {Messages.retryPaymentSubscribe}
                </div>
            </div>,
        ];
    }

    onMount() {
        super.onMount();

        this.attachListener(Controller.paymentMethod, () => this.redraw());
    }
}
